import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { I18NEXT_RESOURCES, EN_GOV, EN } from '@strength/i18n';
import LanguageDetector from 'i18next-browser-languagedetector';
import { environment } from '../../environment';

// This is just for dates, so we don't need to worry about en vs en-GOV
export function getLocale() {
  return navigator?.language ?? EN;
}

// Keeps <html lang> truthful about the language actually rendered. A stale
// `lang` (index.html hardcodes "en") is one of the signals browser translators
// use to decide a page needs translating, which mutates DOM text nodes outside
// React's control and can crash the next reconciliation (SC-3893). Registered
// before init() because LanguageDetector resolves and emits the initial
// `languageChanged` synchronously during init() itself — a listener added
// afterwards would miss that first detection.
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      caches: [],
    },
    resources: I18NEXT_RESOURCES,
    // We force use the US gov translations when the setting is true
    lng: environment.VITE_IS_GOV ? EN_GOV : undefined,
    interpolation: {
      escapeValue: false, // react is already safe from xss
    },
  });

export default i18n;
